/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const DropDownItem = ({ cta_category_id, cta_name, cta_type_id, handleItemClick }) => {
  return <Box onClick={() => handleItemClick(cta_type_id, cta_category_id)}>{cta_name}</Box>;
};

const Box = styled.div`
  border: 1px solid white;
  padding: 8px 8px;
  cursor: pointer;
  :hover {
    border-radius: 4px;
    background: ${Palette.PrimaryGray._100};
  }
  :active {
    border-radius: 4px;
    border: 1px solid ${Palette.Primary._300};
    background: ${Palette.Primary._000};
  }
`;
